module.exports = __webpack_public_path__ + "img/home.f0379c95.svg";